"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BriarBulwarkAbilityHandler = exports.BriarBulwarkActorAbilityFactory = exports.BriarBulwarkAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const Duration_1 = require("../../core/Duration");
const core_1 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
const LinkedEffects_1 = require("../../core/effects/core/LinkedEffects");
const DamageReciprocate_1 = require("../../core/effects/core/DamageReciprocate");
const Damage_1 = require("../../core/Damage");
const DamageType_1 = require("../../core/enums/DamageType");
const enums_1 = require("../../core/enums");
class BriarBulwarkAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.BriarBulwark;
        this.__typeName = "BriarBulwark";
    }
}
exports.BriarBulwarkAbilityArgs = BriarBulwarkAbilityArgs;
let BriarBulwarkActorAbilityFactory = class BriarBulwarkActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("BriarBulwark", "AllAllies", 3);
    }
};
BriarBulwarkActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("BriarBulwark")
], BriarBulwarkActorAbilityFactory);
exports.BriarBulwarkActorAbilityFactory = BriarBulwarkActorAbilityFactory;
let BriarBulwarkAbilityHandler = class BriarBulwarkAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        container.applyAbilityAnimation({
            sequence,
            abilityKey: ability.args.__typeName,
            fallback: "casting",
            animatedId: ability.invokerId,
            onAnimated(sequence) {
                const allies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllAllies);
                for (const allyId of allies) {
                    const [focus, power] = container.getAttributeScores(allyId, [
                        enums_1.AttributeType.Focus,
                        enums_1.AttributeType.Power
                    ]);
                    const focusOrPower = focus > power ? "Focus"
                        : "Power";
                    container.applyBuff({
                        sequence,
                        creatorId: ability.invokerId,
                        targetId: allyId,
                        duration: Duration_1.Duration.Turns(3),
                        effect: new LinkedEffects_1.LinkedEffectsEffectArgs([
                            new DamageReciprocate_1.DamageReciprocateEffectArgs(new Damage_1.Damage(DamageType_1.DamageType.Nature, container.getPercentOfBaseAttributeScore(allyId, 25, focusOrPower))),
                        ], false),
                        onApplied: sequence => sequence.push(new core_1.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(allyId, "feet"), "GreenEnergyCircle"))
                    });
                }
            }
        });
    }
};
BriarBulwarkAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.BriarBulwark)
], BriarBulwarkAbilityHandler);
exports.BriarBulwarkAbilityHandler = BriarBulwarkAbilityHandler;
